import { Component, HostListener } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap'

import { ModalComponent } from 'common/util.modals'
import { TranslateDirective } from 'common/locale/directives/translate.directive'
import { CheckboxComponent } from 'common/util/components/checkbox.component'
import { TranslatePipe } from 'common/locale'

import type { ConflictResolution, FileConflictOptions } from '../services/fileConflict.service'

@Component({
  selector: 'file-conflict-modal',
  templateUrl: './fileConflictModal.component.html',
  imports: [
    TranslateDirective,
    CheckboxComponent,
    FormsModule,
    NgbTooltip,
    TranslatePipe,
  ],
})
export class FileConflictModalComponent extends ModalComponent<FileConflictOptions, ConflictResolution> {
  readonly options = this.params

  @HostListener('document:keydown.enter', ['$event'])
  @HostListener('document:keydown.space', ['$event'])
  protected onEnter (event: KeyboardEvent) {
    event.preventDefault()
    event.stopPropagation()
    this.doOverwrite()
  }

  @HostListener('document:keydown.escape')
  protected onEscape () {
    this.doCancel()
  }

  doOverwrite () {
    this.complete({
      pasteFile: this.options.pasteFile,
      applyToAll: this.options.applyToAll,
      resolution: 'overwrite',
    })
  }

  doRename () {
    this.complete({
      pasteFile: this.options.pasteFile,
      applyToAll: this.options.applyToAll,
      resolution: 'rename',
    })
  }

  doSkip () {
    this.complete({
      pasteFile: this.options.pasteFile,
      applyToAll: this.options.applyToAll,
      resolution: 'skip',
    })
  }

  doCancel () {
    this.complete({
      pasteFile: this.options.pasteFile,
      applyToAll: this.options.applyToAll,
      resolution: 'cancel',
    })
  }
}
